import { PropsWithChildren } from 'react';
import { ButtonProps, buttonClassNames } from './button';
import { Icon, IconName, IconSize } from './icons';

type LinkProps = PropsWithChildren & {
  to: string;
  leftIconName?: IconName;
  rightIconName?: IconName;
  className?: string;
  onClick?: () => void;
};

function InternalLink({
  children,
  to,
  leftIconName,
  rightIconName,
  className,
  onClick,
}: LinkProps): JSX.Element {
  return (
    <a href={to} className={className} onClick={onClick}>
      {leftIconName && (
        <Icon name={leftIconName} size={IconSize.SMALL} color="#000000" />
      )}
      {children}
      {rightIconName && (
        <Icon name={rightIconName} size={IconSize.SMALL} color="#000000" />
      )}
    </a>
  );
}

export function Link({ className, ...props }: LinkProps): JSX.Element {
  return (
    <InternalLink
      {...props}
      className={['aura--link', className].join(' ').trim()}
    />
  );
}

export function LinkAsButton({
  size,
  disruptive,
  className,
  block,
  flavor,
  ...props
}: LinkProps &
  Pick<ButtonProps, 'disruptive' | 'flavor' | 'size' | 'block'>): JSX.Element {
  return (
    <InternalLink
      {...props}
      className={buttonClassNames({
        size,
        flavor,
        disruptive,
        className: ['aura--link-as-button', className].join(' ').trim(),
        block,
      })}
    />
  );
}
